import { render, staticRenderFns } from "./FormInputIconPicker.vue?vue&type=template&id=3992a378"
import script from "./FormInputIconPicker.vue?vue&type=script&lang=js"
export * from "./FormInputIconPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports